import { avatarColor, initials } from "@/lib/format";

export const Avatar = ({ user, size = 36, radius, className = "", style, ...rest }) => {
  const name = user?.display_name || user?.name || "?";
  return (
    <span
      className={`tc-avatar ${className}`}
      style={{ width: size, height: size, borderRadius: radius ?? Math.max(4, Math.round(size * 0.22)), background: user?.avatar_url ? "#eee" : avatarColor(user?.id || name), fontSize: Math.max(8, Math.round(size * 0.4)), ...style }}
      {...rest}
    >
      {user?.avatar_url ? <img src={user.avatar_url} alt={name} loading="lazy" /> : initials(name)}
    </span>
  );
};

export const Presence = ({ presence, className = "" }) => <span className={`tc-presence ${presence === "active" ? "" : "is-away"} ${className}`} data-testid="presence-dot" />;
